import ContinuePage from "@components/ContinuePage"

export default function PetsWhyPetsProfilePage() {
  return <ContinuePage emoji="🐾" translationKey="petsWhyPetsProfile" />
}
